import React from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

export default function PrestatairesModal({
  handleClose,
  show,
  image,
  addOrUpdatePrestataire,
  handleImageChange,
  setImage,
  errorMessage,
  name,
  setName,
  errorHeavyFile,
  errorNotASquare,
  errorFormatFile,
  warningTooSmall,
  nameModal,
}) {
  return (
    <Modal show={show} size="lg" onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{nameModal} Prestataire</Modal.Title>
      </Modal.Header>

      <Form
        onSubmit={(e) => {
          e.preventDefault();
          const reader = new FileReader();
          reader.onload = () => {
            const base64 = reader.result.split(",")[1];
            addOrUpdatePrestataire(base64);
          };
          reader.readAsDataURL(image);
        }}
      >
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              required
              autoFocus
              value={name}
              onChange={(e) => {
                //handleInputChange(e);
                setName(e.target.value);
              }}
              placeholder="Nom du prestataire"
              name="name"
            />
          </Form.Group>
          {errorMessage && (
            <div className="col-md-12 mb-3 p-1">
              <Alert variant="danger" className="m-0">
                {errorMessage}
              </Alert>
            </div>
          )}
          <Form.Group>
            <Form.Label>Télécharger une image</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) => {
                handleImageChange(e);
              }}
            />
          </Form.Group>
          <div
            className="drop-box text-center border rounded p-3"
            onDrop={(e) => {
              e.preventDefault();
              const selectedFile = e.dataTransfer.files[0];
              setImage(selectedFile);
            }}
            onDragOver={(e) => e.preventDefault()}
          >
            <p className="mb-3">
              Glisser et déposer le fichier pour l'importer
            </p>
            <p className={`m-0 ${errorFormatFile ? "red" : ""}`}>
              Formats acceptés : JPG ou PNG
            </p>
            <p className="m-0">
              <span className={`m-0 ${errorNotASquare ? "red" : ""}`}>
                Votre visuel doit être dans un format carré (L = l)
              </span>{" "}
              et{" "}
              <span className={`m-0 ${errorHeavyFile ? "red" : ""}`}>
                ne pas peser plus de 5mo.{" "}
              </span>
            </p>
            <p className={`m-0 ${warningTooSmall ? "text-warning" : ""}`}>
              Résolution conseillée : 200 x 200
            </p>
          </div>
          {image && (
            <div className="text-center">
              <img
                src={URL.createObjectURL(image)}
                width="150px"
                height="150px"
                alt="preview"
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              handleClose();
            }}
          >
            Annuler
          </Button>
          <Button
            variant="success"
            type="submit"
            disabled={
              !image || errorNotASquare || errorHeavyFile || errorFormatFile
            }
          >
            Valider
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
